const NS = 'SiteHeaderBottomSubMenuWidget';
const CLS = 'siteHeaderBottomSubMenuWidget';

export class SiteHeaderBottomSubMenuWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.itemPadding = 16; // Left/right padding

		this.$siteHeaderBottomSubMenuItemsWidget = this.$element.children(`[data-wg="SiteHeaderBottomSubMenuItemsWidget"]`);
		this.defineDepth(this.$siteHeaderBottomSubMenuItemsWidget, 0);

		this.initActiveElement();

		this.$element.on(`${CLS}.dropdown.deactivate`, () => {
			this.$siteHeaderBottomSubMenuItemsWidget.trigger(`siteHeaderBottomSubMenuItemsWidget.dropdown.deactivate`, {});
		});
	}

	/**
	 * Displays the active item (by opening its respective parent dropdowns)
	 */
	initActiveElement() {
		let $initialActiveElement = this.$element.find('[data-active="true"]');

		// Recursive loop to all parent dropdowns
		let activateDropdown = ($element) => {
			if($element && $element.length > 0) {
				$element.parent('.siteHeaderBottomSubMenuItemsWidget').trigger('siteHeaderBottomSubMenuItemsWidget.dropdown.activate', {
					element: $element,
					animate: false
				});

				let $parentElement = $element.parent('.siteHeaderBottomSubMenuItemsWidget').parents('.siteHeaderBottomSubMenuItemsWidget-dropdown').first();
				activateDropdown($parentElement);
			}
		};

		if($initialActiveElement && $initialActiveElement.length === 1) {
			// If the item is a link
			if($initialActiveElement.hasClass('siteHeaderBottomSubMenuItemsWidget-link')) {
				let $dropdownElement = $initialActiveElement.parent('.siteHeaderBottomSubMenuItemsWidget').parents('.siteHeaderBottomSubMenuItemsWidget-dropdown').first();
				activateDropdown($dropdownElement);
			}
			// If the item is a dropdown
			else if($initialActiveElement.hasClass('siteHeaderBottomSubMenuItemsWidget-dropdown')) {
				activateDropdown($initialActiveElement);
			}
		}
		else if($initialActiveElement && $initialActiveElement.length > 1) {
			console.error(`${NS}::Error`, 'Please ensure there is only a single item link/dropdown) that has the attribute of [data-active="true"].');
		}
	}

	// Recursive function that defines the depth of the siteHeaderBottomSubMenuItemsWidget
	defineDepth($element, depth) {
		$element.attr('data-depth', depth);

		let multiplier = depth === 2 ? this.itemPadding : this.itemPadding * depth;

		let indentPadding = (this.itemPadding) + multiplier;
		let paddingStyle = `0 ${this.itemPadding}px 0 ${indentPadding}px`;

		$element.children('.siteHeaderBottomSubMenuItemsWidget-item').css({
			padding: paddingStyle
		});

		$element.children('.siteHeaderBottomSubMenuItemsWidget-dropdown').children('.siteHeaderBottomSubMenuItemsWidget-item').css({
			padding: paddingStyle
		});

		let $children = $element.children('.siteHeaderBottomSubMenuItemsWidget-dropdown').children('.siteHeaderBottomSubMenuItemsWidget-dropdown-content').children('.siteHeaderBottomSubMenuItemsWidget-dropdown-content-inner').children('[data-wg="SiteHeaderBottomSubMenuItemsWidget"]');
		if($children && $children.length > 0) {
			let innerDepth = depth + 1;
			this.defineDepth($children, innerDepth);
		}
	}
}
